/* eslint-disable import/prefer-default-export */
import * as lc from '../../utils/lodashCustom';

export function restructurePaginationModel(data) {
  return {
    currentPage: lc.get(data, 'currentPage'),
    pageCount: lc.get(data, 'pageCount'),
    perPage: lc.get(data, 'perPage'),
    totalCount: lc.get(data, 'totalCount')
  };
}

export function restructureMessageModel(data) {
  return {
    message: lc.get(data, 'message'),
    id: lc.get(data, 'id'),
    success: lc.get(data, 'success'),
    code: lc.get(data, 'code')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/common/restructuring/index.js